import React from "react";
import { cn } from "@/lib/utils";

export const Praha = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>(({ className, ...props }, ref) => (
  <svg
    ref={ref}
    className={cn("", className)}
    {...props}
    fill="#6f9c76"
    height="570"
    stroke="#ffffff"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth=".5"
    version="1.2"
    viewBox="0 0 1000 570"
    width="1000"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="features">
      <path
        d="M383.4 216.9l0.4 1.1 0.2 0.5 0.4 0.5 0.5 0.4 0.4 0.2 0.6 0.3 0.1 0 0.3 0.1 0.2 0.1 1.5 0.4 0.9 0.2 0.6 0 1.5 0.1 0.6 0.1 0.5 0.2 0.2 0.1 0 0.1 0.3 0.4 0.2 1 0.1 0.6 0.2 0.5 0.1 0 0.3 0.3 1.1 0.5 0.7 0.5 0.4 0.1 0.8 0.3 0.4 0.2 1.3 1.1 0.2 0.3 0.7 1.2 0.1 0.2 0.2 0.4 0.1 0.3 0 0.6 0 0.6-0.2 0.6-0.1 0.1-0.2 0.3-0.4 0.3-0.5 0.2-0.3 0.1-0.6 0.2-1.5 0.3-0.1 0.1-1.2 0.6-0.4 0.1-0.1 0-0.9 0-0.8 0.1-0.3 0-0.6 0.1-0.2 0.1-0.3 0.2-0.1 0.2-0.2 0.3 0 0.5 0.1 0.6 0.1 0.3 0.1 0.2 0 0.1 0.4 0.4 0.9 0.7 0.3 0.3 0.4 0.8 0.1 0.5 0 0.4-0.1 3-0.1 0.6-0.2 0.5-0.2 0.5-0.5 0.6-0.4 0.5-0.6 0.5-0.5 0.8-0.3 0.4-0.1 0.1-0.2 0.1-0.3 0.2-0.5 0.3-0.9 0.1-1-0.1-0.5-0.2-0.2-0.2-0.3-0.3-0.4-0.9-0.2-0.1-0.1-0.1-0.3-0.2-0.6-0.2-1.9-0.2-0.6-0.2-0.6-0.1-3.5 0.5-0.9 0.3-0.6 0.2-1.3 0.7-0.4 0.4-0.5 0.4-1.5 0.9-0.2 0.1-0.2 0.1-0.1 0-1.3 0.4-0.5 0.3-0.4 0.3-0.8 0.7-0.1 0-0.7 0.8-0.1 0-0.2 0.2-0.5 0.4-0.9 0.7-0.5 0.3-0.8 0.5-0.7 0.3-0.6 0.1-1.6 0.3-3.2 0.3-0.7 0.1-0.1 0.1-0.2 0.1-0.3 0.3-0.3 0.5-0.5 1.6-0.5 0.8-0.7 0.8-0.9 0.6-0.7 0.2-0.7 0.1-1.1 0-0.7-0.1-0.7-0.1-0.2-0.2-1.1-0.9-0.1-0.2-0.3-0.6-0.2-0.9 0.1-0.4 0.2-0.9 0.8-2.5 0.1-0.6 0.1-0.7-0.1-0.3-0.2-0.6-0.3-0.4-0.5-0.3-0.4-0.1-1.4-0.4-0.7-0.3-0.4-0.4-0.2-0.2-0.2-0.6-0.1-0.7 0-0.4-0.1-2.2-0.1-0.7-0.3-0.6-0.4-0.4-0.4-0.3-0.6-0.3-0.4-0.1-0.5-0.2-0.5-0.4-1.9-2.3-0.8-1.4-0.2-0.3-0.6-0.6-0.6-0.5-0.3-0.4-0.1-0.1-0.1-0.6 0.1-0.3 0.1-0.3 0.1-0.3 0.5-0.3 0.1 0 0.9-0.4 0.7-0.4 0.4-0.1 0.7-0.2 0.4-0.3 0.2-0.3 0.1-0.2 0.1-0.3 0.1-0.4-0.1-0.2 0-0.2-0.3-0.3-0.5-0.2-0.8-0.3-0.5-0.2-1-0.9-0.6-0.5-1.8-1.6-0.3-0.4 0-0.1-0.2-0.4 0-0.3 0.1-0.3 0.3-0.5 0-0.1 1.4-1 0.3-0.1 0.6-0.1 2.1-0.2 1.1-0.2 1.8-0.9 0.7-0.5 0.5-0.2 0.1 0 0.2 0 0.5 0.1 0.9 0.4 0.4 0.2 1.3 0.3 1-0.1 0.9-0.2 0.6-0.3 0.3-0.6 0.4-0.9 0.3-1.3 0.2-0.7 0.1-0.2 0.4-0.4 0-0.1 0.5-0.3 0.3-0.2 0.7-0.1 0.6-0.1 0.5 0 1.4 0.1 0.2 0 1.1 0.1 0.6 0.1 0.8-0.6 0.7-0.5 0.6-0.6 0.3-0.3 1-0.7 0.1-0.1 0.1-0.1 0.6-0.1 1.9-0.2 0.8-0.2 0.5-0.2 1.3-1.2 0.2-0.1 0.4-0.3 0.9-0.2 2.6-0.2 1.1-0.4 1.9-0.5 0.4-0.1 0.3 0 0.4 0 0.3 0.1 0.3 0.3 0.2 0.4 0.1 0 0.4 1.3 0.3 0.5 0.1 0.1 0.3 0.3 0.2 0.1 0.6 0.2 1 0.3 0.1 0.1 0.6 0.2 1.7 0.8 0.3 0.2 0.4 0.3 0.4 0.5 0.1 0.3 0.2 0.5z"
        id="CZ10"
        name=" Praha"
      ></path>
    </g>

    <g id="label_points">
      <circle className=" Praha" cx="367.4" cy="231.8" id="CZ10"></circle>
    </g>
  </svg>
));
